import React, { FC, MouseEvent } from 'react';
import './slide-image.sass';
import { IPost } from '../../../../../../../shared/types/Post';
import CallToActionGroup, {
  ICTAConfig,
} from '../../../../../../../shared/components/call-to-action-group/call-to-action-group';
import { globalConfig, ThemeLayoutOptions } from '../../../../../../../shared/config/config';
import Logger from '../../../../../../../shared/utils/logger';
import ProductIcon from '../../../../../../../shared/components/ecommerce/product-icon/product-icon';
import FileLinkClientService from '../../../../../../../shared/services/file-link-client.service';
import { Nullable } from '../../../../../../../shared/types/Typescript-utils';
import SourceIcon from '../../../../../../../shared/components/source-icon/source-icon';

interface ISlideImageConfig {
  url: string;
  imageEffect?: Nullable<string>;
  noImagesScaling?: boolean;
  themeLayout?: Nullable<string>;
}

export interface IPropsSlideImage {
  onClick: (post: IPost) => void;
  config: ISlideImageConfig;
  post: IPost;
  shouldDisplayCta: boolean;
  activeCTAIndex: number;
  prevCta: (event: MouseEvent<Element>) => void;
  nextCta: (event: MouseEvent<Element>) => void;
  onCtaClick: (post: IPost) => void;
  ctaConfig: ICTAConfig;
  tabIndex: number;
  isProduct?: boolean;
  isSourceIconHidden?: boolean;
}

const SlideImage: FC<IPropsSlideImage> = ({
  onClick,
  post,
  config: { url, imageEffect, noImagesScaling, themeLayout },
  shouldDisplayCta,
  activeCTAIndex,
  prevCta,
  nextCta,
  onCtaClick,
  ctaConfig,
  tabIndex,
  isProduct,
}) => {
  const {
    attributes: { type, attachment_id: attachmentId, video_url: videoUrl },
  } = post;

  const onImageClick = () => onClick && onClick(post);

  let transformedImage = '';
  if (url) {
    try {
      const fileLinkClient = new FileLinkClientService({
        url: url,
        imageEffect: imageEffect,
        noImagesScaling,
      });

      transformedImage = fileLinkClient
        .rotate()
        .noMetadata()
        .resize({ width: globalConfig.fileStack.width.mediumMediaQuery })
        .applyEffect()
        .autoImage()
        .compress()
        .toString();
    } catch (error) {
      Logger.warning(error);
      transformedImage = 'wrongpath';
    }
  }

  return (
    <div className="slide-image" onClick={onImageClick} style={{ backgroundImage: `url('${transformedImage}')` }}>
      {shouldDisplayCta && (
        <div className="slide-image__cta-wrapper slide-image__cta-wrapper--with-image">
          <CallToActionGroup
            ctaConfig={ctaConfig}
            post={post}
            onCtaClick={onCtaClick}
            cta={[post.cta[activeCTAIndex]]}
            prevCta={prevCta}
            nextCta={nextCta}
            isInSliderTheme={true}
            tabIndex={tabIndex}
          />
        </div>
      )}
      {themeLayout === ThemeLayoutOptions.IMAGE && type && (
        <div className="slide-image__source-icon-wrapper">
          <SourceIcon type={type} size="lg" />
        </div>
      )}
      {isProduct && <ProductIcon />}
      {videoUrl && transformedImage && <div className='slide-image__play-button' />}
    </div>
  );
};

export default SlideImage;
